<template>
  <side-bar
    :sections="sections"
    @open="setSideOpen"
    @close="setSideClosed"
    ref="sidebar"
    noExitButton="true"
    class="sideNavigation"
    :key="$t('frontend_groovevideo_videos_sidebar_settings')"
    origin="GrooveVideo"
    logo="GrooveVideoLogo"
  >
    <template :slot="$t('frontend_groovevideo_videos_sidebar_library')">
    </template>

    <template :slot="$t('frontend_groovevideo_videos_sidebar_categories')">
    </template>

    <template :slot="$t('frontend_groovevideo_videos_sidebar_analytics')">
    </template>

    <template slot="Storage settings">
    </template>

    <template slot="Encoder settings">
    </template>

    <template slot="header">
      <div class="flex flex-col">
        <div>GrooveVideo</div>
      </div>
    </template>
  </side-bar>
</template>

<script>
import SideBar from '../design-system/sidebar-adapter';
import Library from '../assets/images/icons/Library.svg';
import Sitemap from '@/assets/images/icons/Sitemap.svg';
import AnalyticsIcon from '@/assets/images/icons/Analytics.svg';
import StorageIcon from '@/assets/images/icons/storage.svg';
import EncoderIcon from '@/assets/images/icons/encoder.svg';

export default {
  name: 'SidebarMenu',
  data() {
    return {};
  },
  created() {},
  methods: {
    setSideOpen(side) {
      if (side == this.$t('frontend_groovevideo_videos_sidebar_library')) {
        this.sendToMyVideos();
      } else if (
        side == this.$t('frontend_groovevideo_videos_sidebar_categories')
      ) {
        this.sendToCategories();
      } else if (
        side == this.$t('frontend_groovevideo_videos_sidebar_analytics')
      ) {
        this.sendToAnalytics();
      } else if (side == 'Storage settings') {
        this.sendToStorageSettings();
      } else if (side == 'Encoder settings') {
        this.sendToEncoderSettings();
      }
    },

    setSideClosed(side) {},

    sendToAnalytics() {
      this.$router.push({ name: 'analytics' });
    },

    sendToEngagement() {
      this.$router.push({ name: 'engagement' });
    },

    sendToCategories() {
      this.$router.push({ name: 'categories' });
    },

    sendToMyVideos() {
      this.$router.push({ name: 'videos' });
    },
    sendToStorageSettings() {
      this.$router.push({ name: 'storageSettings' });
    },
    sendToEncoderSettings() {
      this.$router.push({ name: 'encoderSettings' });
    },
  },
  computed: {
    sections() {
      return [
        {
          name: this.$t('frontend_groovevideo_videos_sidebar_library'),
          icon: Library,
          doNotOpen: 1,
        },
        {
          name: this.$t('frontend_groovevideo_videos_sidebar_categories'),
          icon: Sitemap,
          doNotOpen: 1,
        },
        {
          name: this.$t('frontend_groovevideo_videos_sidebar_analytics'),
          icon: AnalyticsIcon,
          doNotOpen: 1,
        },
        {
          name: 'Storage settings',
          icon: StorageIcon,
          doNotOpen: 1,
        },
        {
          name: 'Encoder settings',
          icon: EncoderIcon,
          doNotOpen: 1,
        },
      ];
    },
  },
  components: {
    SideBar,
  },
};
</script>

<style>
.sideNavigation .activeSideBar svg path {
  fill: #fd6481;
}

.sideNavigation .activeSideBar svg rect {
  stroke: #fd6481;
}
</style>
